import {
    ParsedSipCancelReasonsResponseType,
    SelectedSipReason,
    SipCancelReasonsResponseType,
} from '../../components/dashboard/commercial/Sip/types';
import { SIP_CANCEL_REASON, SIP_CANCEL_REASON_SUCCESS } from '../types/commercialTransactions';

export type SipCancelReducerType = {
    sipReasons: ParsedSipCancelReasonsResponseType;
    selectedSipReason: SelectedSipReason | null;
    loading: boolean;
};

export const SET_SIP_CANCEL_REASON = 'SET_SIP_CANCEL_REASON';
export const CLEAR_SIP_CANCEL_REASON = 'CLEAR_SIP_CANCEL_REASON';

type SipCancelActionType =
    | {
          type: typeof SIP_CANCEL_REASON_SUCCESS;
          body: SipCancelReasonsResponseType;
      }
    | {
          type: typeof SIP_CANCEL_REASON;
          body: null;
      }
    | {
          type: typeof SET_SIP_CANCEL_REASON;
          body: SelectedSipReason;
      }
    | {
          type: typeof CLEAR_SIP_CANCEL_REASON;
      };

const initialState = {
    sipReasons: [],
    selectedSipReason: null,
    loading: false,
};

const sipCancelReducer = (
    state: SipCancelReducerType = initialState,
    action: SipCancelActionType,
): SipCancelReducerType => {
    switch (action.type) {
        case SIP_CANCEL_REASON_SUCCESS:
            return {
                ...state,
                sipReasons: action.body.map((reason) => ({
                    ...reason,
                    code: String(reason.code),
                })),
                selectedSipReason: {
                    code: String(action.body[0].code),
                    reason: action.body[0].reason
                },
                loading: false,
            };
        case CLEAR_SIP_CANCEL_REASON:
            return {
                ...state,
                selectedSipReason: null,
            };
        case SIP_CANCEL_REASON:
            return {
                ...state,
                loading: true,
            };
        case SET_SIP_CANCEL_REASON:
            return {
                ...state,
                selectedSipReason: action.body,
            };
        default:
            return state;
    }
};

export default sipCancelReducer;
